
import { Wine } from "../types";

const DB_NAME = "DivinoDB";
const STORE_NAME = "wines";
const DB_VERSION = 1;

const getDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
};

export const saveWinesLocally = async (profile: string, data: any): Promise<void> => {
  const db = await getDB();
  
  // Registriamo il profilo nel localStorage per il ProfileSelector
  const profilesRaw = localStorage.getItem('divino_profiles_list') || '[]';
  const profiles = JSON.parse(profilesRaw);
  if (!profiles.includes(profile)) {
    profiles.push(profile);
    localStorage.setItem('divino_profiles_list', JSON.stringify(profiles));
  }

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    // Salviamo l'intero oggetto (che può contenere {wines, history} o solo array)
    const request = store.put(data, profile);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const loadWinesLocally = async (profile: string): Promise<any> => {
  const db = await getDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readonly");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.get(profile);
    request.onsuccess = () => resolve(request.result || []);
    request.onerror = () => reject(request.error);
  });
};

export const deleteProfileData = async (profile: string): Promise<void> => {
  const db = await getDB();
  // Rimuoviamo il profilo dalla lista
  const profilesRaw = localStorage.getItem('divino_profiles_list') || '[]';
  let profiles = JSON.parse(profilesRaw);
  profiles = profiles.filter((p: string) => p !== profile);
  localStorage.setItem('divino_profiles_list', JSON.stringify(profiles));

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.delete(profile);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};
